// Stealth-Agent FE — shell. Renders nested routes (Org Intelligence / Work Summary)
// via <Outlet/>. Guards: main_admin/switch + allowlisted orgs.
import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { canUserAccessStealthIntelligence } from '../orgGating';

export default function StealthShell() {
  const { user } = useAuth() || {};
  // Allow main_admin/switch and orgs that are in the stealth intelligence allowlist.
  const allowed = canUserAccessStealthIntelligence(user);
  if (user && !allowed) {
    return <Navigate to="/dashboard" replace />;
  }
  return (
    <div className="min-h-full bg-gray-50 dark:bg-gray-950">
      <Outlet />
    </div>
  );
}
